import type { SVGProps } from 'react';
const SvgClearCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.23865 6.65113L6.54265 1.34863L1.23865 6.65113ZM1.23865 1.34863L6.54265 6.65113L1.23865 1.34863Z"
      fill="#007CF0"
    />
    <path
      d="M1.23865 6.65113L6.54265 1.34863M1.23865 1.34863L6.54265 6.65113"
      stroke="#757575"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export default SvgClearCross;
